// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlaySquareFilledSvg from "@fishx/icons-svg/es/asn/PlaySquareFilled";
import FishxIcon from '../components/FishxIcon';

var PlaySquareFilled = function PlaySquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlaySquareFilledSvg
  }));
};

PlaySquareFilled.displayName = 'PlaySquareFilled';
export default React.forwardRef(PlaySquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PlaySquareFilled.js
// module id = 3810
// module chunks = 0